<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="left_nav">
        <!-- navCall = item.num -->
        <div @click="changeTab(item)" :class="item.num===navCall?'navSelected':''"
             v-for="item in NavList"
             :key="item.num">
          {{ item.title }}
        </div>
      </div>
      <div class="form_wrap">
        <div class="toolsIntroduce">
          <div class="left">
            <img src="../img/face.png" alt="">
          </div>
          <div class="right">
            <p>
              功能介绍
            </p>
            <span style="display: block">
              {{create_form.mode=='sora2'?'将创意转化为动态超级逼真的视频':'输入提示词或上传图片即可生成任何风格且超级逼真的视频'}}
            </span>
          </div>
        </div>
        <div class="options_item" v-if="navCall===2">
          <div class="item_title" flex-align>
            <div class="text">上传参考图（必填）</div>
          </div>
          <div class="Reference_image">
            <el-upload :http-request="$projectUpload"
                class="upload-demo"
                drag
                :action="fileApi+'/api/front/upload/rawfile/?soft=1&ftype=sora&storage=ali_oss'"
                :show-file-list="false"
                accept=".jpg,.png"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                multiple>
              <div v-if="tenImg" class="yesUpload">
                <img :src="cdn_url_replace(tenImg)" alt="" class="yesUpload_img">
                <!-- <div class="yesUpload_icon" @click.stop="create_form.img_url=''"> -->
                <div class="yesUpload_icon" @click.stop="deleteImg">
                  <i class="el-icon-delete"></i>
                </div>
              </div>
              <div v-else class="noUpload">
                <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                <div> 只能上传jpg/png文件，且不超过10MB</div>
              </div>
            </el-upload>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">视频描述</div>
          </div>
          <div class="btm_area_con">
            <div>
                <textarea class="text" rows="4" v-model="create_form.desc"
                          placeholder="请输入创意描述，包含内容主体+动作/场景，一键生成视频"></textarea>
            </div>
            <div class="depict_switch">
              <div class="switch">
                <el-switch
                    style="zoom: 0.7"
                    @change="getPromptData4()"
                    active-value="1"
                    inactive-value="0"
                    active-color="#5865f2"
                    inactive-color="#53555f"
                    v-model="auto_spell">
                </el-switch>
                <span style="margin-left: 4px;font-size: 12px">一键优化描述词</span>
              </div>
              <div class="empty" @click="clearText()">清空</div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">模型选择</div>
          </div>
          <div class="model_list">
            <div class="quality">
              <div @click="changeModel('model',model) " v-for="(model,index) in platform_list"
                   :class="['common_btn',create_form.mode===model.name2?'quality_btns':'quality_btn']">
                {{ model.name }}
                <div class="need_vip" v-if="model.need_vip">VIP
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="options_item" v-if="create_form.mode!='sora2'">
          <div class="item_title" flex-align>
            <div class="text">清晰度</div>
          </div>
          <div class="model_list">
            <div class="quality">
              <div @click="changeModel('is_hd',model.type) " v-for="(model,index) in clarityList1"
                   :class="['common_btn',create_form.is_hd==model.type?'quality_btns':'quality_btn',(index==1&&create_form.is_hd==0&&create_form.seconds==25)? 'selectVersion' : '',]">
                {{ model.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">生成时长</div>
          </div>
          <div class="model_list" v-if="create_form.mode=='sora2'">
            <div class="quality">
              <div @click="changeModel('duration',model.type) "
                   v-for="(model,index) in durationList1"
                   :class="['common_btn',create_form.seconds==model.type?'quality_btns':'quality_btn']">
                {{ model.name }}
              </div>
            </div>
          </div>
          <div class="model_list" v-if="create_form.mode=='sora2_pro'">
            <div class="quality">
              <div @click="changeModel('duration',model.type) "
                   v-for="(model,index) in durationList2"
                   :class="['common_btn',create_form.seconds==model.type?'quality_btns':'quality_btn'
                   ,(index==2&&create_form.is_hd==1)? 'selectVersion' : '',]">
                {{ model.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">视频比例</div>
          </div>
          <div class="video_size_list">
            <div :class="['sise_item',{'active':video_size==item.value}]" v-for="item in size_list" :key="item.value" @click="selectSize(item)">
              <img :src="item.url" alt="" class="size_img">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="newSubList">
      <div class="newSumit newSumitOthers" @click="sendMsg">
        提交任务<span style="font-size: 12px;">（消耗{{ jifen }}积分）</span>
        <!-- <div class="subText">（消耗10积分）</div> -->
      </div>
    </div>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>

  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
import AliCdn from '../../utils/ali_cdn'

export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      cdnOptions: {
        cdnDomain: "cdnmjimg2024.m.nengshuohuihua.com"
      },
      scoreCode: 25,
      newscoreCode: 35,
      tenCurent: 0,
      tagAvt: 1,
      tenImg: '',
      create_form: {
        img_url: "",//普通
        desc: "",
        auto_optimize: false,
        style: 0,
        size: '16:9',
        duration: 10,
        soft: 8,
        aspect_ratio: 6,
        mode: 'sora2',
        img_urls: "",//以图片作为结尾帧
        seconds: 10,// 默认视频时长
        exploreMode: false, //true探索模式 false积分模式
        is_hd: 0 , // 清晰度
        create_type: 1,
        model_version: 'sora2',
      },
      sending: false,
      navCall: 1,
      NavList: [
        {title: '文生视频', num: 1,},
        {title: '图生视频', num: 2,},
      ],
      fileApi: FILE_API_SERVER,
      frame: false,
      fileAPI: API_SERVER,
      imgDialogVisible: false,
      model_desc: '',
      platform_list: [
        {
          name: "Sora2",
          name2: "sora2",
          need_vip: 1,
          desc: '即将开放OpenAI-Sora大师级模型，长达60秒巨作',
          platform: 3
        },
        {name: "Sora2 Pro", name2: "sora2_pro", need_vip: 1, desc: 'Runway Gen 3 影视级动画特效，生成效果较好', platform: 1},

      ],
      duration_list: [
        {name: '5秒', need_vip: 1, value: 5}, {name: '10秒', need_vip: 1, value: 10}
      ],
      clarityList1: [
        {name: '标清', type: '0',},
        {name: '高清', type: '1',},
      ],
      durationList1: [
        {name: '10秒', type: '10', value: 10},
        {name: '15秒', type: '15', value: 15},
      ],
      durationList2: [
        {name: '10秒', type: '10', value: 10},
        {name: '15秒', type: '15', value: 15},
        {name: '25秒', type: '25', value: 25},
      ],
      exploreMode_list: [
        {value: true, name: "排队",},
        {value: false, name: "不排队",},
      ],
      video_list: [],
      noMore: false,
      loading: false,
      page: 1,
      intervalId: null,

      select_rec_img: {
        img_url: ''
      },
      timer: null,
      max_mj_id: 0,
      checkIds: [],
      sendLoading: false,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleSelectList: [], // 选择样例
      sampleTimer: null,
      success_icon: true,
      definition: [
        {name: '标清', value: 0},
        {name: '高清', value: 1},
      ],
      perIncan: false, // ai提示词是否返回
      auto_spell: '1', // ai提示词是否关闭
      size_list: [
        {name: '16:9', value: '16:9',url:require('./img/16^9.png')},
        {name: '9:16', value: '9:16',url:require('./img/9^16.png')},
      ],
      video_size: '16:9',
      jifen:10,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    isInputtype() {
      return this.$store.state.isInputtype;
    },
    isInputVal() {
      return this.$store.state.isInputVal;
    },
  },
  created() {
    if (localStorage.getItem('semText')) {
      this.create_form.desc = localStorage.getItem('semText')
    }
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
    localStorage.setItem('soft',1)
   
    if(this.create_form.mode == 'sora2'){
        // data.size = this.video_size
      this.$store.commit('setSoraModel', 1)
    }else{
      this.$store.commit('setSoraModel', 2)
    }

  },
  mounted() {

  },

  methods: {
    cdn_url_replace(url, o_url, c_url){
      if (!c_url){
        c_url = 'https://cdnmjimgnas.m.nengshuohuihua.com'
      }
      if (!o_url){
        o_url = 'https://mjimg.zhanjuzhe.cn'
      }
      if (url.indexOf('https://mjimg2024.oss-cn-beijing.aliyuncs.com') > -1){
        return AliCdn.signUrl(url, this.cdnOptions)
      }
      return url.replace(o_url, c_url)
    },
    selectSize(item){
      this.video_size = item.name
    },
    clearText() {
      this.create_form.desc = ''
      localStorage.removeItem('semText')
      localStorage.removeItem('sampleNa')
    },
    setScore() {
      if (this.create_form.create_type == 1) {
        console.log('文生视频')
        if (this.create_form.duration == 5 && this.create_form.is_hd == 0) {
          this.scoreCode = 25
          this.newscoreCode = 35
        } else if (this.create_form.duration == 10 && this.create_form.is_hd == 0) {
          this.scoreCode = 50
          this.newscoreCode = 70
        } else if (this.create_form.duration == 5 && this.create_form.is_hd == 1) {
          this.scoreCode = 35
        } else if (this.create_form.duration == 10 && this.create_form.is_hd == 1) {
          this.scoreCode = 70
        }
      } else {
        console.log('图省事视频')
        // if (!this.create_form.img_urls) {
        if (this.create_form.duration == 5 && this.create_form.is_hd == 0) {
          this.scoreCode = 25
          this.newscoreCode = 35
        } else if (this.create_form.duration == 10 && this.create_form.is_hd == 0) {
          this.scoreCode = 50
          this.newscoreCode = 70
        } else if (this.create_form.duration == 5 && this.create_form.is_hd == 1) {
          // this.scoreCode = 35
        } else if (this.create_form.duration == 10 && this.create_form.is_hd == 1) {
          // this.scoreCode = 70
        }


      }

    },
    changeModel(type,model) {
      if(type == 'model'){
        this.create_form.mode = model.name2
        this.create_form.is_hd = 0
        this.changeModel('is_hd',0)
        this.create_form.seconds = 10
        if(model.name2=='sora2_pro'){
          // console.log('sora2_pro');
          
          this.$store.commit('setSoraModel', 2)
        }else{
          //  console.log('!sora2_pro');
          this.$store.commit('setSoraModel', 1)
        }
      }else if(type == 'is_hd'){

        if (this.create_form.is_hd == 0 && this.create_form.seconds == 25) {
          return
        }
        if (model == 1 && this.create_form.seconds == 25) {
          this.create_form.seconds = 10
        }
        this.create_form.is_hd = model
        // 改变数组
        if (this.create_form.is_hd == 0) {
          this.size_list = [
            {name: '16:9', value: '16:9', url: require('./img/16^9.png')},
            {name: '9:16', value: '9:16', url: require('./img/9^16.png')},
          ]
        } else {
          this.size_list = [
            {name: '21:9', value: '21:9', url: require('./img/16^9.png')},
            {name: '9:21', value: '9:21', url: require('./img/9^16.png')},
          ]
        }
        // 根据清晰度自动调整尺寸比例
        this.updateSizeByQuality()
      }else if(type == 'duration'){
        if (model == 25 && this.create_form.is_hd == 1) {
          return
        }
        this.create_form.seconds = model
      }
      this.handleJf()
    },
    // 根据清晰度更新尺寸比例
    updateSizeByQuality() {
      // console.log('updateSizeByQuality')
      const currentSize = this.video_size
      const isHD = this.create_form.is_hd == 1
      // 尺寸映射关系
      const sizeMapping = {
        '16:9': {hd: '21:9', sd: '16:9'},  // 横屏：高清21:9, 标清16:9
        '9:16': {hd: '9:21', sd: '9:16'},  // 竖屏：高清9:21, 标清9:16
        '21:9': {hd: '21:9', sd: '16:9'},  // 横屏超高清
        '9:21': {hd: '9:21', sd: '9:16'}   // 竖屏超高清
      }
      if (sizeMapping[currentSize]) {
        this.video_size = isHD ? sizeMapping[currentSize].hd : sizeMapping[currentSize].sd
      }
    },
    // 判断积分
    handleJf() {

      if (this.create_form.mode == 'sora2') {
        if (this.create_form.seconds == 10 && this.create_form.is_hd == 0) {
          this.jifen = 10 // 标清 10秒
        } else if (this.create_form.seconds == 15 && this.create_form.is_hd == 0) {
          this.jifen = 15 // 标清 15秒
        }
      } else {
        if (this.create_form.seconds == 10 && this.create_form.is_hd == 0) {
          this.jifen = 100 // 标清 10秒
        } else if (this.create_form.seconds == 15 && this.create_form.is_hd == 0) {
          this.jifen = 150 // 标清 15秒
        } else if (this.create_form.seconds == 25 && this.create_form.is_hd == 0) {
          this.jifen = 200 // 标清 15秒
        } else if (this.create_form.seconds == 10 && this.create_form.is_hd == 1) {
          this.jifen = 150 // 高清 10秒
        } else if (this.create_form.seconds == 15 && this.create_form.is_hd == 1) {
          this.jifen = 200 // 高清 15秒
        }
      }

    },
    changeTab(data) {
      console.log(data);
      
      this.create_form.create_type = data.num
      this.create_form.is_hd = 0
      if (data.num == 1) {
        this.definition = [{name: '标清', value: 0},
          {name: '高清', value: 1},]
        this.setScore()
      } else {
        if (this.create_form.img_urls) {
          this.create_form.is_hd = 0
          this.definition = [{name: '高清', value: 0},]
          if (this.create_form.duration == 5) {
            this.scoreCode = 25
          }
        } else {
          this.setScore()
        }
      }
      this.navCall = data.num
    },
    deleteImg() {
      if (this.tagAvt == 2) {
        this.definition = [{name: '标清', value: 0}, {name: '高清', value: 1},]
        this.create_form.is_hd = 0
        this.create_form.img_urls = ''
        this.setScore()
      } else {
        this.create_form.img_url = ''
      }
      this.tenImg = ''
    },

    tendIt(data) {
      this.tagAvt = data
      this.tenImg = data == 1 ? this.create_form.img_url : this.create_form.img_urls
      if (this.create_form.img_urls && this.create_form.img_url == '') {
        this.setScore()
      }
    },



    getProfile() {
      let invite_code = localStorage.getItem("invite_code") || "";
      this.$http.get(`/front/user/profile/`, {
        params: {
          invite_code: invite_code,
          app_id: APP_ID
        }
      }).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).finally(() => {

      })
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },
    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },
    //发送消息
    sendMsg() {
      // console.log(1)
      // console.log(this.create_form)
      // return

      // 检查是否为样例体验模式（未登录 + 有样例索引 + 首次生成）
      const isSampleMode = !this.isLogin && 
                          localStorage.getItem('sampleNa') !== null && 
                          !localStorage.getItem('sampleUserList')
      
      if (isSampleMode) {
        // 样例体验模式：允许未登录用户体验一次样例生成
        console.log('样例体验模式')
        const sampleIndex = localStorage.getItem('sampleNa')
        if (this.sampleList[sampleIndex]) {
          this.sampleList[sampleIndex].status = 1      // 设置状态为生成中
          this.sampleList[sampleIndex].progress = 0    // 进度为0
          // 保存到 localStorage，标记已体验过
          localStorage.setItem('sampleUserList', JSON.stringify(this.sampleList[sampleIndex]))
          // 触发事件，切换到"生成记录"tab 展示样例结果
          this.$emit('semForm')
          return
        }
      }
      
      // 普通模式：检查登录状态
      if (!this.checkLogin()) {
        return false
      }
      if(!utils.setOptData(this.userInfo,'btn_sora_create')){
          return
      }
      if(this.create_form.create_type==2){
        if(!this.create_form.img_url){
          this.$message.warning('请上传图片')
          return
        }
      }
      // 已登录用户的后续逻辑
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      if (this.create_form.desc === "") {
        this.$message.warning('请输入文字信息')
        return
      }
      if (this.create_form.desc.length > 2000) {
        this.$message.warning('描述信息不能超过2000字符')
        return
      }
      if (this.create_form.navCall === 1) {
        this.create_form.img_url = ""
      }
      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      if (this.auto_spell > 0) {
        console.log('ai提示词')
        if (!this.perIncan) {
          this.$store.commit('setisInputVal', this.create_form.desc)
          this.$store.commit('setisInputtype', 'Stable Diffusion')
          this.$store.commit('setisInputValshow', true)
          return;
        }
      }
      // 在提交前拼接比例到描述词
      const ratioText = `--生成比例 ${this.video_size}`;
      let desc = this.create_form.desc;

      // 移除旧的比例描述（如果存在）
      desc = desc.replace(/--生成比例\s+\d+:\d+/g, '').trim();
      // 拼接新的比例描述
      this.create_form.desc = desc ? `${desc} ${ratioText}` : ratioText;
      // if (this.sendLoading) {
      //   this.$message.warning('正在提交任务！')
      //   return
      // }
      // console.log('提交00', this.create_form)
      // return
      this.create_form.name = this.create_form.desc
      this.create_form.text_prompt = this.create_form.desc
      this.create_form.duration = this.create_form.seconds
      this.create_form.is_optimize = this.create_form.auto_optimize
      // this.sendLoading = true
      console.log('提交0', this.create_form)
      // return
      this.submitQuestion(this.create_form);

    },
    submitQuestion(data, parent_msg_code, i) {
      this.sending = true;
      // console.log('提交1', data)
      // return
      // 提交问题
      // data.source = "pc";
      if(this.create_form.mode == 'sora2'){
        // data.size = this.video_size
        data.model_version = 'sora2'
        this.$store.commit('setSoraModel', 1)
        
      }else{
        data.model_version = 'sora2_pro'
         this.$store.commit('setSoraModel', 2)
      }
      // return
      this.perIncan = false
      this.$http.post('/front/aivideo/', data).then((res) => {
        this.create_form.is_hd = 0
        this.isTips = false
        if (res.status == 200) {
          this.getProfile()
          this.inputVal = "";
          // this.checkIds.push(res.data.draw.draw_id)
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          // this.fetchMsg();
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "expired_gift_score") {
            // 队列已满
            this.$confirm('您的积分已过期，如需继续使用该功能请购买积分或升级套餐', '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    // 上传图片
    handleAvatarSuccess(res, file) {
      if (res.data.error !== '') {
        this.$message.error(res.data.error)
      }
      if (res.status == '200') {
        // this.create_form.img_url = res.data.file_full_url
        if (this.tagAvt == 2) {
          this.definition = [{name: '高清', value: 0},]
          this.create_form.is_hd = 0
          this.select_rec_img.img_urls = res.data.file_url
          this.create_form.img_urls = res.data.file_url
          this.setScore()
        } else {
          this.create_form.img_url = res.data.file_url
          this.select_rec_img.img_url = res.data.file_url
        }
        this.tenImg = res.data.cdn_file_url
      }
    },
    beforeAvatarUpload(rawFile) {

      if (!this.checkLogin()) {
        return false
      }
      if (this.userInfo.is_vip < 1) {
        this.$confirm('您还未开通会员是否开通会员?', '开通会员', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push('/member')
        })
        return false
      }
      const isIMG = rawFile.type === 'image/jpeg' || rawFile.type === 'image/png';
      const isLt10M = rawFile.size / 1024 / 1024 < 10;
      const isSole = true

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(rawFile);
        img.onload = () => {
          let wS = img.width / img.height
          let hS = img.height / img.width
          if (!isIMG) {
            this.$message.error('上传图片只能是 JPG/PNG 格式!');
            return false
          }
          if (!isLt10M) {
            this.$message.error('上传图片大小不能超过 10MB!');
            return false
          }
          resolve({isIMG, isLt10M, isSole});
        }

      })
    },
    selectDefinition(model, index) {
      console.log(model.value)
      this.create_form.is_hd = model.value
      this.setScore()
    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的绘画内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'

        });
      }
    },
  },
  watch: {
    '$store.state.isInputValshow'(newVal) {
      console.log('isInputValshow 变化:', newVal);
      if (!newVal) {
        if (this.isInputtype.length > 0) {
          this.perIncan = true
          this.create_form.desc = this.isInputVal
          this.sendMsg()
        }
      }
    },
  },

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fg1 {
  flex: 1;
}

#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    overflow: hidden;
    flex: 1 1 0%;

    .left_nav {
      margin: 10px 20px;
      padding: 4px 0;
      height: 40px;
      border-radius: 6px;
      border: 1px solid #36373d;
      display: flex;
      align-items: center;
      color: #fff;
      background-color: #313338;

      div {
        flex: 1;
        text-align: center;
        margin: 0 4px;
        cursor: pointer;
      }

      .navSelected {
        background-color: #5865f2;
        border-radius: 4px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .form_wrap {
      overflow-y: auto;
      padding: 5px 15px 60px;
      height: 100%;

      .toolsIntroduce {
        background-color: #1e1f22;
        padding: 16px 14px;
        display: flex;
        border-radius: 5px;
        box-sizing: border-box;
        overflow: hidden;

        .left {
          width: 20px;
          margin-right: 12px;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .right {
          width: calc(100% - 32px);
          flex-grow: 1;
          word-wrap: break-word;

          p {
            font-size: 14px;
            font-weight: 700;
            height: 20px;
            margin-bottom: 5px;
          }

          span {
            font-size: 12px;
            word-wrap: break-word;
            white-space: normal;
          }

        }
      }

      // 绘画描述
      .btm_area_con {
        //position: relative;
        border-radius: 5px;
        border: 2px solid #5865f2;
        padding: 10px 10px;

        .text {
          width: 100%;
          background-color: #2b2d31;
          border: 0;
          color: #b4b9bf;
          font-size: 14px;
          letter-spacing: 1.5px;
          line-height: 20px;
        }

        .depict_switch {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          margin-top: 10px;

          .switch {
            display: flex;
            align-items: center;

            span {
              margin-left: 10px;
            }
          }

          .empty {
            color: #b4b9bf;
            cursor: pointer;
          }

          .empty:hover {
            color: #fff;
          }
        }
      }

      // 模型选择
      .model_list {
        display: flex;


        .model_item {
          border-radius: 6px;
          border: 2px solid #1d2027;
          position: relative;
          overflow: hidden;

          &.active {
            border-color: #5865f2;
          }

          img {
            border: none;
            width: 100%;
          }

          .model_title {
            position: absolute;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.73);
            height: 25px;
            font-size: 12px;
            left: 0;
            bottom: 0;
          }
        }

        .quality {
          display: flex;
          color: #fff;
          font-size: 14px;
          .selectVersion {
            color: #999;
            cursor: auto;
          }



          .need_vip {
            position: absolute;
            color: #f0b132;
            line-height: 17px;
            font-weight: 700;
            top: -8px;
            right: -5px;
          }
          .common_btn{
            cursor: pointer;
            position: relative;
            border-radius: 3px;
            padding: 10px 35px;
            margin: 0 20px 0 0;
          }
          .quality_btn {

            border: 2px solid #393c43;
            background-color: #1d2027;
          }

          .quality_btns {
            border: 2px solid #5865f2;
            background-color: #303245;

          }

        }

      }
      // 视频比例
      .video_size_list {
        display: flex;
        .sise_item {
          height: 80px;
          border-radius: 6px;
          border: 2px solid #393c43;
          // position: relative;
          // overflow: hidden;
          margin: 0 20px 20px 0;
          padding: 10px 20px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .size_img{
            display: block;
            width: 24px;
            height: 24px;
            margin-bottom: 5px;
          }
        }

        .active {
          border-color: #5865f2;
          background-color: #303245;
        }
      }

      // 上传参考图
      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;
        box-sizing: border-box;

        .upload-demo {
          width: 100%;
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 100%;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        /deep/ .el-upload {
          width: 100%;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }


        }
      }

      .tendBox {
        width: 100%;
        height: 60px;
        display: flex;
        align-items: center;
        border: 1px dashed rgb(66, 70, 78);
        border-top: 0;
        // padding:0 20px;
        padding-left: 38px;

        .tendItem {
          width: 130px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 10px 0 5px;
          cursor: pointer;
          position: relative;
          border: 1px solid rgb(66, 70, 78);
          border-radius: 6px;

          .closeTen {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 18px;
            height: 18px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .null {
            width: 30px;
            height: 30px;
          }

          .el-image {
            width: 32px;
            height: 32px;
          }
        }

        .tendItemAct {
          border: 1px solid rgb(88, 101, 242);
        }

        .tago {
          width: 20px;
          height: 20px;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }

          margin: 0 10px;
        }
      }

    }

    .options_item {
      margin: 10px 0 10px;

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      .item_con {
        .el-switch {
          margin-left: 10px;
        }
      }
    }
  }

  //提交按钮
  .bottom_area {
    padding-top: 10px;
    background-color: #2b2d31;
    height: 90px;
    width: 100%;
    padding: 0 30px;

    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;

      /deep/ .el-loading-mask {
        background: none;
      }

      &.disabled_btn {
        cursor: not-allowed;
        background-color: #393b3f;
        user-select: none;
        color: #999;
      }
    }

  }

  .newSubList {
    width: 100%;
    height: 90px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    // justify-content: space-around;
    justify-content: space-between;
    //border-top: 1px solid #42464e;
    padding: 0 15px;

    .newSumit {
      flex-shrink: 0;
      width: 122px;
      height: 55px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #5865f2;
      // text-align: center;
      border-radius: 10px;
      // padding: 0 10px;
      cursor: pointer;
      font-size: 14px;
      // line-height: 19px;
      .subText {
        font-size: 10px;
      }
    }

    .newSumitOther {
      // margin-left: 20px;
      width: 198px;
      position: relative;
      background: linear-gradient(to right, #fd7a57, #fe3f40);

      .subImg {
        position: absolute;
        right: 52px;
        top: 0px;
      }
    }

    .newSumitOthers {
      width: 90%;
      margin: 0 auto;
      background: #5865f2;
      color: #fff;
      display: flex;
      flex-direction: row;
      border-radius: 55px;
    }
  }


}


/deep/ .el-loading-mask {
  background: none;
}
</style>